import { Effects } from 'chessboard/plugins/effects/renderer/types';

export const resignWhite = `<g id="resign_white">
    <g>
      <path class="${Effects.ClassNames.Shadow}" opacity="0.3" d="M9,.5a9,9,0,1,0,9,9A9,9,0,0,0,9,.5Z"></path>
      <circle class="${Effects.ClassNames.Background}" fill="#f8f8f8" cx="9" cy="9" r="8.5"></circle>
      <g>
        <path d="M4.94,5.74H4.89a.63.63,0,0,0-.44.77l2.16,8.09a.63.63,0,0,0,.77.45l0,0a.62.62,0,0,0,.44-.76L5.7,6.18A.62.62,0,0,0,4.94,5.74Z"></path>
        <path d="M12.33,3.88c-2,2.29-3.83-.41-6,1.52a.54.54,0,0,0-.15.25.48.48,0,0,0,0,.29c.22.89.87,3.3,1.12,4.15a.15.15,0,0,0,.26.07c1.92-2.65,4,.27,6.11-1.69A.46.46,0,0,0,13.76,8c-.21-.78-.8-3-1.1-4C12.62,3.84,12.42,3.76,12.33,3.88Z"></path>
      </g>
    </g>
    <path class="${Effects.ClassNames.ComponentShadow}" fill="#e8e8e8" d="M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z"></path>
  </g>`;
